import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [developmentModal, setDevelopmentModal] = useState({ show: false, nodeName: '' });
  const [pendenciesModal, setPendenciesModal] = useState({ show: false, pendencies: [], nodeName: '' });

  const showDevelopmentModal = (nodeName) => {
    setDevelopmentModal({ show: true, nodeName });
  };

  const hideDevelopmentModal = () => {
    setDevelopmentModal({ show: false, nodeName: '' });
  };

  const showPendenciesModal = (pendencies, nodeName) => {
    setPendenciesModal({ show: true, pendencies, nodeName });
  };

  const hidePendenciesModal = () => {
    setPendenciesModal({ show: false, pendencies: [], nodeName: '' });
  };

  return (
    <ModalContext.Provider value={{
      developmentModal,
      pendenciesModal,
      showDevelopmentModal,
      hideDevelopmentModal,
      showPendenciesModal,
      hidePendenciesModal
    }}>
      {children}
    </ModalContext.Provider>
  );
};